function ManageButtonArea(props: any) {
  let myProps = {
    go_write_by_ajax: () => { },
    is_write_mode: false,
    set_is_write_mode: (inData: any) => { },
    goPrint: () => { },
    closePopup: () => { },
    ...props
  };

  return (
    <div className='my_flex_center' >
      <button className='btn btn-sky' onClick={myProps.go_write_by_ajax} >저장</button>
      <button className={"btn btn-dark"}
        onClick={() => {
          myProps.set_is_write_mode(!myProps.is_write_mode);
        }} >
        {myProps.is_write_mode ? "보기 모드" : "수정 모드"}
      </button>
      {!myProps.is_write_mode &&
        <button className='btn btn-sky' onClick={myProps.goPrint} >인쇄</button>
      }
      <button className='btn btn-dark' onClick={() => { myProps.closePopup(); }} >뒤로</button>
    </div>
  );
};
export default ManageButtonArea;